import { CONFIG_NAME } from "../config/loadShellEnv";

export const ENTRY = CONFIG_NAME.split(".")[0] as "mm" | "engage" | "cop";
